import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import ReactInputMask from 'react-input-mask';
import { Column, GridApi } from 'ag-grid-community';

interface IProps {
  parentFilterInstance: any;
  api: GridApi;
  column: Column;
  mask: string;
  normalize: (value: string) => string;
}

export function MaskFloatingFilter({ mask, normalize, parentFilterInstance, column, api }: IProps, ref: any) {
  const currentFilter = api.getFilterModel()[column.getColId()];

  const agInputFieldRef = useRef();
  const [value, setValue] = useState(currentFilter ? currentFilter.filter : '');

  useEffect(() => {
    if (agInputFieldRef) {
      (agInputFieldRef.current as HTMLDivElement).setAttribute('ref', 'eFloatingFilterInput');
    }
  }, []);

  useEffect(() => {
    parentFilterInstance((instance: any) => instance.onFloatingFilterChanged('contains', value));
  }, [value]);

  useImperativeHandle<any, any>(ref, () => ({
    onParentModelChanged: (parentModel: any) => setValue(!parentModel ? '' : parentModel.filter),
  }));

  const onValueChanged = (event) => setValue(normalize(event.target.value));
  return (
    <div className="ag-floating-filter-input">
      <div className="ag-text-field ag-input-field" ref={agInputFieldRef}>
        <div className="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper">
          <ReactInputMask
            className="ag-input-field-input ag-text-field-input"
            mask={mask}
            value={value}
            onChange={onValueChanged}
          />
        </div>
      </div>
    </div>
  );
}

export default forwardRef(MaskFloatingFilter);
